module.exports = __webpack_public_path__ + "static/img/loginIcon.66a0e9af.png";